<template>
<th @click="show_options = !show_options">
<slot>{{ label || id }}</slot>
<span class="datatable-sort-arrow fas fa-caret-down"></span>
<div class="filter-wrapper" v-show="show_options">
<div class="filter-toggle">
    <ul class='datatable-filter filter-menu'>
        <li v-for="(option,index) in column_options" v-bind:index="index"  v-bind:key="option.value">
            <chc-checkbox v-model="option.isActive" :label="option.value" @input="onFilterChange(option)"></chc-checkbox>
        </li>
    </ul>
</div>
</div>
</th>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'app-datatable-filter',
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    options: {
      type: Array
    },
    defaultFilter: {
      type: Array,
      default: null
    }
  },
  mounted () {
  },
  data () {
    return {
      show_options: false,
      column_options: {},
    }
  },
  methods: {
    init () {
      this.column_options = this.options.reduce(function (acc, curVal, i) {
        acc[i] = {
          value: curVal,
          isActive: false,
        }
        return acc
      }, [])
      if (this.defaultFilter) {
        for (var i = this.column_options.length - 1; i >= 0; i--) {
          if (this.defaultFilter.indexOf(this.column_options[i].value) !== -1) {
            this.column_options[i].isActive = true
          }
        }
      }
    },
    onFilterChange ($option) {
      this.show_options = !this.show_options
      if ($option.isActive) this.$emit('addFilter', $option.value)
      else this.$emit('removeFilter', $option.value)
      this.$emit('options', _.map(_.filter(this.column_options, (e) => e.isActive), (e) => e.value))
    },
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import 'mixins';
@import '../../style/variables';

.app-datatable {
  th {
      position:relative;
      &.sortable {
          cursor: pointer;
      }

      @include no-select();
  }

  .datatable-sort-arrow {
      @include vertical-align(absolute);
      margin-left: 3px;
      font-size: .875rem;
      color: $dark-purple;
  }
}
</style>

<style lang="scss">
@import 'mixins';
@import '../../style/variables';

.filter-wrapper {
  position: absolute;
  top: .65rem;
  right: 1rem;
  ul {
    margin: 0;
    padding: 0;
  }
  .filter-toggle {
    text-align: right;
    list-style-type: none;
    margin: 0;
    padding: .35rem 0;
    .icon {
      color: $dark-purple;
    }
    .filter-menu {
      display: block;
      position: absolute;
      top: 1.4rem;
      right: 0;
      background-color: #ffffff;
      border-top: 2px solid $yellow;
      border-radius: 0 0 .25rem .25rem;
      box-shadow: 0 3px 4px $md-grey;
      padding: .75rem .75rem 0 .75rem;
      list-style-type: none;
      margin: 0;
      width: 225px;
      z-index: 100;
      text-align: left;
      &:before {
        content: '';
        display: block;
        height: 3px;
        position: absolute;
        top: -5px;
        width: 100%;
        left: -1px;
      }
      li {
        margin: 0;
      }
      a {
        margin-bottom: .75rem;
        display: inline-block;
      }
      .inline-label {
        font-weight: normal;
        color: $text-color;
      }
      .field {
        margin-bottom: 1rem;
      }
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/Datatables/AppDatatableFilter.vue